@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.selected-service-view-container {
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 12em;

  border: 0.223em solid colors.$input-background-color;
  border-radius: 0.667em;

  background-color: #fff;

  .connection-info {
    display: flex;
    flex-direction: row;
    justify-content: baseline;
    align-items: center;

    position: relative;

    min-height: 4.44444444444em; // maps to 80px

    border-bottom: 0.1em solid colors.$input-background-color;

    .arrow {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      margin-left: 1.5em;
      margin-top: 0.4em;

      color: colors.$primary-text-color;

      svg {
        width: 1.5em;
        height: auto;

        @include responsive.xs-small-phone {
          width: 1em;
        }

        @include responsive.phone-and-up {
          width: 2em;
        }
        @include responsive.tablet-and-up {
          width: 2.5em;
        }
      }
    }

    .service-to-service {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      padding-left: 2em;

      &:last-child {
        padding-left: 1em;
      }

      span {
        font-size: 1.22222222em; // maps to 22px
        font-weight: 700;
      }

      @include responsive.phone {
        span {
          display: none;
        }
      }

      img {
        width: 1.778em; // maps to 32px
        height: auto;

        margin-right: 0.5em;

        filter: brightness(0%);
      }
    }

    .remove-action {
      position: absolute;
      right: 1.778em;

      a {
        text-decoration: underline;

        color: colors.$secondary-text-color;

        font-size: 0.888888888em; // maps to 16px
      }
    }
  }

  .service-details-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;

    margin: 2.666666666em; // maps to 48px

    @include responsive.phone {
      flex-direction: column;
      align-items: center;
    }

    .service-icon-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      min-width: 11.44444444em; // maps to 206px
      height: 11.44444444em;

      border-radius: 0.222222222em; // maps to 4px

      img {
        width: 9em;
        height: auto;
      }
    }

    .service-details {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      margin-left: 2.666666666em; // maps to 48px

      @include responsive.phone {
        flex-grow: 0;
        justify-content: center;
        align-items: center;

        margin: 1em 0 0 0;
      }

      h2 {
        margin-top: 0;
        margin-bottom: 0.625em;
        font-size: 1.777777777em; // maps to 32px
      }

      .action-link {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;

        text-decoration: underline;

        color: colors.$secondary-text-color;

        font-size: 0.888888888em; // maps to 16px

        svg {
          margin-left: 0.5em;
          margin-bottom: 0.4em;

          vertical-align: middle !important;
        }
      }

      > div p {
        font-size: 0.888888888em; // maps to 16px

        line-height: 169%;
      }
    }
  }

  .service-steps {
    .step-type-selector {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;

      font-size: 1.111111111em; // maps to 20px
      font-weight: 700;

      border-bottom: 0.1em solid colors.$input-background-color;

      li {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 8.888888888em;

        color: #a7a7a7;

        cursor: pointer;

        div {
          padding-bottom: 0.85em;

          &.active {
            border-bottom: 0.1499999999999em solid colors.$primary-text-color; // maps to 3px

            color: colors.$primary-text-color;
          }
        }
      }
    }

    .step-type-details {
      position: relative;

      font-size: 0.888888888em; // maps to 16px
      line-height: 169%;

      min-height: 5em;

      .spinner {
        position: absolute;
        top: 2.5em;
        left: 0;
        width: 100%;
      }

      .note {
        margin: 2em auto;
        text-align: center;
      }

      ul {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        margin: 0 0 2em 2.777777777em; // maps to 80px

        li {
          flex-grow: 0;
          flex-shrink: 0;

          width: 25%;
          margin: 2em 8% 0 0;

          @include responsive.phone {
            width: 37%;
          }

          .title {
            font-weight: 700
          }

          .description {
            margin-top: 0;

            p {
              margin-block-start: 0;
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
